import { useCallback, useState } from 'react'
import { FaEye } from 'react-icons/fa'

import { Modal } from '~/components/Modal'
import { PaymentPlan } from '~/modules/sales/types'

import { PlanDetailsModalContent } from './PlanDetailsModal'

type Props = {
  plan: PaymentPlan
}

export const PlanDetailsButton: React.FC<Props> = ({ plan }) => {
  const [showModal, setShowModal] = useState<boolean>(false)

  const handleToggleModal = useCallback(() => {
    setShowModal((state) => !state)
  }, [])

  return (
    <>
      <button
        className='py-2 px-4 rounded-md bg-gpa-blue-500 hover:bg-blue-800 text-white'
        onClick={handleToggleModal}
      >
        <FaEye size={18} />
      </button>
      <Modal visible={showModal}>
        <PlanDetailsModalContent onClose={handleToggleModal} data={plan} />
      </Modal>
    </>
  )
}
